<script setup lang="ts">
import { computed } from 'vue';
import { DndPathSegment } from './sub-components/dnd-path-segment';

const props = defineProps<{
  path: string;
}>();

const segments = computed(() => {
  const names = props.path.split('/').filter(Boolean);
  let cumulativePath = '';
  return names.map((name) => {
    cumulativePath += `/${name}`;
    return { name, path: cumulativePath };
  });
});
</script>

<template>
  <template v-for="segment in segments" :key="segment.path">
    <span class="path-bar-separator">&gt;</span>
    <DndPathSegment :segment="segment.name" :path="segment.path" />
  </template>
</template>

<style scoped>
.path-bar-separator {
  flex-shrink: 0;
  color: #a6b3d6;
}
</style>
